<template>
  <div class="admin-json-viewer">
    <VueJsonPretty
      :data="normalizedValue"
      :deep="deep"
      show-icon
      show-length
      show-line
      show-line-number
      virtual
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { normalizeJsonForDisplay } from "@/libs/aiDos/adminShared";

const props = withDefaults(
  defineProps<{
    value: unknown;
    deep?: number;
  }>(),
  { deep: 4 }
);

const normalizedValue = computed(() => normalizeJsonForDisplay(props.value));
</script>

<style scoped lang="scss">
.admin-json-viewer {
  background: #111827;
  border: 1px solid #374151;
  border-radius: 0.5rem;
  color: #f9fafb;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas,
    "Liberation Mono", "Courier New", monospace;
  font-size: 0.875rem;
  line-height: 1.45;
  max-height: 36rem;
  overflow: auto;
  padding: 1rem;
}

:deep(.vjs-tree) {
  background: transparent;
  color: #f9fafb;
  font-family: inherit;
}

:deep(.vjs-tree-node:hover) {
  background: rgba(255, 255, 255, 0.06);
}

:deep(.vjs-node-index) {
  color: #6b7280;
  display: inline-block;
  margin-left: -3.5rem;
  padding-right: 1rem;
  text-align: right;
  user-select: none;
  width: 2.5rem;
}

:deep(.vjs-key) {
  color: #93c5fd;
}

:deep(.vjs-value-string) {
  color: #86efac;
}

:deep(.vjs-value-number) {
  color: #fbbf24;
}

:deep(.vjs-value-boolean) {
  color: #c084fc;
}

:deep(.vjs-value-null) {
  color: #f87171;
}

:deep(.vjs-brackets),
:deep(.vjs-comma),
:deep(.vjs-quotes) {
  color: #d1d5db;
}
</style>
